import { Button as DsButton, type IconName } from '@cinch-nx/shared-ui'

export interface ButtonProps {
  icon: IconName
  label: string
  url: string
}

export const Button = ({ icon, label, url }: ButtonProps) => (
  <DsButton
    icon={icon}
    iconPosition="left"
    label={label}
    size="small"
    variant="outlined"
    as="a"
    href={url}
  />
)
